import {colors, Divider, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import {LoadingOverlay} from '../../../components/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import {getMe} from '../../../graphql/auth';
import userRoleLevel from '../../../utils/userRoleLevel';
import getRole from '../getRole.api';
import RoleEdit from './RoleEdit';
import RoleView from './RoleView';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    divider: {
        backgroundColor: colors.grey[300]
    },
}));

const RoleDetails = () => {
    const {history, match}: RouteComponentProps<{ id: string }> = useReactRouter();
    const classes = useStyles();
    const {id} = match.params;
    const newRole = id === 'new';
    const blankRole = {
        id: -1,
        name: '',
        ident: '',
        description: '',
        active: false,
        level: 3,
        permission: [],
    };
    const roleData = newRole ? {loading: false, data: null, error: null} : getRole(Number.parseInt(id));
    const meData = getMe();
    const roleLevel = userRoleLevel(meData.data!.me);
    const title = 'Edit Role';
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        if (roleData.error) {
            enqueueSnackbar(`There was an error loading Role ${id}`, {variant: 'error'});
            history.push('/roles');
        }
    }, [roleData.error]);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="Users" title={title}/>
            <Divider className={classes.divider}/>
            <LoadingOverlay loading={roleData.loading}>
                {!roleData.loading && roleData.data && roleData.data.role && roleData.data.role.level! <= roleLevel && (
                    <RoleView role={roleData.data.role}/>
                )}
                {!roleData.loading && roleData.data && roleData.data.role && roleData.data.role.level! > roleLevel && (
                    <RoleEdit role={roleData.data.role}/>
                )}
                {newRole && (
                    <RoleEdit role={blankRole}/>
                )}
            </LoadingOverlay>
        </Page>
    );
};

export default RoleDetails;
